import { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Checkbox } from '../../../../common/html/checkbox'
import { Element } from '../../../../common/html/element'
import { Loading } from '../../../../common/loading'
import { PopupAction } from '../../../../common/popup/PopupAction'
import { ScrollComponent } from '../../../../common/scrollComponent'
import { removeAccents } from '../../../../helpers/common'
import { Input } from '../../../../library/common/html/input'
import { postMoveOrCopyCompany } from '../../../../library/savedPortfolios/detailsPortfolios/store/thunk'
import { CreatePortfolio } from '../../../../library/savedPortfolios/portfoliosOverview/components/CreatePortfolio'
import {
  selectDataRawTable,
  selectIsLoadingTableSavedPortfolio,
} from '../../../../library/savedPortfolios/portfoliosOverview/store/slice/slice'
import { getSearchPortfolio } from '../../../../library/savedPortfolios/portfoliosOverview/store/thunk'
import { selectIdActive, selectSuggest } from '../store/slice'

export const PopupAddToPort = ({ isShow, setShow, functionClear }) => {
  const dispatch = useDispatch()

  const data = useSelector(selectDataRawTable)
  const loadingSearch = useSelector(selectIsLoadingTableSavedPortfolio)
  const id = useSelector(selectIdActive)
  const dataTable = useSelector(selectSuggest())
  const idsSelected = Object.values(dataTable)
    .filter((item) => item?.check)
    .map((key) => key?.organizationId)

  const [listCheck, setListCheck] = useState([])
  const [textSearch, setTextSearch] = useState('')
  const [isShowCreateForm, setIsShowCreateForm] = useState(false)

  const dataFormat = useMemo(() => {
    return data.filter((item) =>
      removeAccents(item.portfolioName.toLowerCase()).includes(
        removeAccents(textSearch.trim().toLowerCase()),
      ),
    )
  }, [textSearch, data])

  const handleApply = () => {
    dispatch(
      postMoveOrCopyCompany({
        porfolioId: id,
        organizationIds: idsSelected,
        targetPorfolioIds: listCheck,
        addType: 'IN',
        isMove: false,
      }),
    )
      .unwrap()
      .then(() => {
        functionClear && functionClear()
        setShow(false)
      })
      .catch(() => {})
  }

  const handleAfterCreate = () => {
    dispatch(
      getSearchPortfolio({
        InputSearch: '',
        Page: 1,
        PageSize: 300,
      }),
    )
  }

  useEffect(() => {
    dispatch(
      getSearchPortfolio({
        InputSearch: '',
        Page: 1,
        PageSize: 300,
      }),
    )
  }, [])

  return (
    <>
      {isShow && (
        <PopupAction
          isShow={isShow}
          title="dashboard.suggestDetail.addToPortfolio"
          handleClose={() => setShow(false)}
          btnSubmit={{
            label: 'OK',
            event: (e) => {
              e.stopPropagation()
              handleApply()
            },
          }}
          btnCancel={{
            label: 'library.filterSetting.CANCEL',
            isI18n: true,
            event: (e) => {
              e.stopPropagation()
              setShow(false)
            },
          }}
        >
          <div>
            <div
              style={{ paddingBottom: 12 }}
              className="dFlex cursorPointer alignItemsCenter"
            >
              <Input
                containerStyle={{
                  flex: 1,
                  height: '28px',
                }}
                placeHolder="library.savePortfolio.SEARCH_PORTFOLIO"
                type="text"
                isSearch
                value={textSearch}
                onChange={setTextSearch}
              />
              <Element
                elementName="p"
                style={{ color: '#2C73E8', paddingLeft: 12 }}
                onClick={() => setIsShowCreateForm(true)}
              >
                <Translate value="library.savePortfolio.CREATE_NEW_PORTFOLIO" />
              </Element>
            </div>

            <Element
              className="positionRelative"
              style={{
                backgroundColor: '#FFFFFF',
              }}
            >
              {loadingSearch ? (
                <Loading />
              ) : !dataFormat.length ? (
                <>
                  <div
                    className="textCenter fstItalic"
                    style={{
                      padding: '10px 12px',
                    }}
                  >
                    <Translate value="common.NO_DATA" />
                  </div>
                </>
              ) : (
                <ScrollComponent autoHeight autoHeightMax={400}>
                  <div
                    style={{
                      padding: '10px 12px',
                    }}
                  >
                    {dataFormat.map((item) => (
                      <ItemCheckBox
                        key={item.portfolioId}
                        item={item}
                        setListCheck={setListCheck}
                        listCheck={listCheck}
                      />
                    ))}
                  </div>
                </ScrollComponent>
              )}
            </Element>
          </div>
        </PopupAction>
      )}
      {isShowCreateForm && (
        <CreatePortfolio
          isShow={isShowCreateForm}
          setShow={setIsShowCreateForm}
          handleAfterCreate={handleAfterCreate}
        />
      )}
    </>
  )
}

const ItemCheckBox = ({ item, setListCheck, listCheck }) => {
  return (
    <Element
      className={'dFlex alignItemsCenter gap1'}
      style={{
        paddingTop: 6,
        paddingBottom: 6,
        borderBottom: 'solid 1px #D5D5D5',
      }}
    >
      <Checkbox
        title={item?.portfolioName}
        checked={listCheck.includes(item.portfolioId)}
        onChange={() => {
          setListCheck((prevList) => {
            if ([...prevList].includes(item.portfolioId)) {
              return prevList.filter((key) => key !== item.portfolioId)
            }
            return [...prevList, item.portfolioId]
          })
        }}
        isCheckOnClickText
        styleIcon={{ fontSize: 15, paddingRight: 8 }}
        style={{
          lineHeight: '16px',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          width: 390,
        }}
      />
    </Element>
  )
}
